import React from "react";
import { FileUp, MailCheck, Table2 } from "lucide-react";

const STEPS = [
  {
    icon: FileUp,
    title: "1 · Attach or paste",
    body: "Drop vendor PDFs and cheque/letterhead images, paste the email body, or do both together.",
  },
  {
    icon: MailCheck,
    title: "2 · Extract",
    body: "Claude reads every page and the mail text, then splits each vendor it finds into its own row.",
  },
  {
    icon: Table2,
    title: "3 · Review & export",
    body: "Fix anything inline, watch PAN/IFSC validation flags, then export a clean 16-column CSV.",
  },
];

export const EmptyState = () => (
  <section className="vde-card p-6 sm:p-8" data-testid="empty-state">
    <h2 className="text-base font-semibold text-foreground">
      No vendors extracted yet
    </h2>
    <p className="mt-1 text-sm text-muted-foreground">
      Add a document or an email above and hit Extract. Nothing is typed by hand again.
    </p>
    <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-3">
      {STEPS.map(({ icon: Icon, title, body }) => (
        <div
          key={title}
          className="rounded-xl border border-border bg-secondary/50 p-4"
        >
          <div className="mb-2 flex h-9 w-9 items-center justify-center rounded-lg bg-card">
            <Icon className="h-4.5 w-4.5 text-primary" aria-hidden="true" />
          </div>
          <p className="text-sm font-semibold text-foreground">{title}</p>
          <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{body}</p>
        </div>
      ))}
    </div>
  </section>
);

export default EmptyState;
